/**
 * @deprecated
 * use {@link PSpaceSemantic}
 * or {@link PSpacePrimitive}
 */
export enum PSpaceSize {
  ZERO = 'zero',
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
  /**
   * @deprecated
   * use the `growMobile`/`growLaptop`/`growDesktop` props on {@link PSpace} instead
   */
  GROW = 'grow',
  HEADLINE = 'headline',
  SUB_HEADLINE = 'sub_headline',
}

export enum PSpaceSemantic {
  NONE = 'none',
  TABS = 'tabs',
  BUTTONS = 'buttons',
  TAG = 'tag',
  INSIDE_FORMS = 'insideForms',
  CARDS = 'cards',
  FORMS = 'forms',
  ELEMENTS = 'elements',
  OFFSET = 'offset',
}

export enum PSpacePrimitive {
  SPACE_000 = 'space-000',
  SPACE_002 = 'space-002',
  SPACE_004 = 'space-004',
  SPACE_008 = 'space-008',
  SPACE_012 = 'space-012',
  SPACE_016 = 'space-016',
  SPACE_020 = 'space-020',
  SPACE_024 = 'space-024',
  SPACE_028 = 'space-028',
  SPACE_032 = 'space-032',
  SPACE_040 = 'space-040',
  SPACE_048 = 'space-048',
}
